import { type PointBezierHandle } from '..';
import { type Point } from '../../../utils/math';

export const initHandlesFromPoints = (points: Point[]): PointBezierHandle[] => {
  return points.map((p) => ({
    before: [p[0], p[1]],
    after: [p[0], p[1]],
  }));
};

export const offsetHandles = (
  handles: PointBezierHandle[] | undefined,
  dx: number,
  dy: number,
): PointBezierHandle[] | undefined => {
  if (!handles) return handles;

  return handles.map((handle) => ({
    before: [handle.before[0] + dx, handle.before[1] + dy],
    after: [handle.after[0] + dx, handle.after[1] + dy],
  }));
};

export const appendHandleForPoint = (
  handles: PointBezierHandle[] | undefined,
  point: Point,
): PointBezierHandle[] | undefined => {
  return handles
    ? [
        ...handles,
        {
          before: point,
          after: point,
        },
      ]
    : undefined;
};
